import React from 'react';
import styled from 'styled-components';

type Props = {
  style?: React.CSSProperties;
  children: React.ReactNode;
};

export default function SpacingContainer({ style, children }: Props) {
  return (
    <SpacingWrapper style={style} data-testid="spacing-container">
      {children}
    </SpacingWrapper>
  );
}

const SpacingWrapper = styled.div``;
